import { ThemeUIStyleObject } from 'theme-ui';

import type { GridProps } from './Grid';

export const stylePropsGrid = ({
  autoFlow,
  align,
  center,
  margins,
  maxWidth,
  columns,
  minColumnWidth
}: Partial<GridProps>): ThemeUIStyleObject => ({
  display: 'grid',
  gridAutoFlow: autoFlow,
  alignItems: align,
  justifyContent: center ? 'center' : 'initial',
  justifyItems: align === 'flex-start' ? 'stretch' : align,
  m: margins,
  maxWidth: maxWidth,
  gridTemplateColumns: Array.isArray(columns)
    ? columns.map((columnCount) =>
        columnCount ? `repeat(${columnCount}, minmax(${minColumnWidth ? minColumnWidth : 0}, 1fr))` : null
      )
    : `repeat(${columns}, minmax(${minColumnWidth ? minColumnWidth : 0}, 1fr))`
});
